import { AVAILABLE_ACTIVITY_WORD_CLOUD } from "../actions/types";

let activityWordCloudDataState = { wordCloud: [], totalPages: 0, currentPage: 1 };

export default function (state = activityWordCloudDataState, action) {

    switch (action.type) {
        case AVAILABLE_ACTIVITY_WORD_CLOUD:
            if (state.wordCloud.length === 0) {
                return {
                    ...state,
                    wordCloud: action.payload.content.wordCloud,
                    totalPages: action.payload.content.totalPages,
                    currentPage: parseInt(action.payload.content.currentPage),
                }
            } else {
                let concatResult = {};
                concatResult.wordCloud = state.wordCloud.concat(action.payload.content.wordCloud);
                concatResult.totalPages = action.payload.content.totalPages;
                concatResult.currentPage = parseInt(action.payload.content.currentPage);
                return {
                    ...state,
                    wordCloud: concatResult.wordCloud,
                    totalPages: concatResult.totalPages,
                    currentPage: concatResult.currentPage,
                }
            }

        default:
            return state;
    }
}

